"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoisesAuth = exports.FirebaseApp = void 0;
const firebase_1 = __importDefault(require("firebase"));
exports.FirebaseApp = firebase_1.default;
class MoisesAuth {
    constructor(config, session) {
        this.config = config;
        this.session = session;
        this.instance = null;
        try {
            this.instance = firebase_1.default.initializeApp(this.config.firebase);
            if (this.config.recaptchaToken) {
                const appCheck = firebase_1.default.appCheck(this.instance);
                // Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
                // key is the counterpart to the secret key you set in the Firebase console.
                appCheck.activate(this.config.recaptchaToken, 
                // Optional argument. If true, the SDK automatically refreshes App Check
                // tokens as needed.
                true);
            }
        }
        catch (err) {
            // Its fine!
        }
    }
    updateFirebaseToken(token) {
        this.session.token = token;
    }
    async signInWithEmailAndPassword({ email, password }) {
        const { user } = await firebase_1.default
            .auth()
            .signInWithEmailAndPassword(email, password);
        this.session.user = user;
        const token = await (user === null || user === void 0 ? void 0 : user.getIdToken(true));
        if (token)
            this.updateFirebaseToken(token);
        return user;
    }
}
exports.MoisesAuth = MoisesAuth;
